import axios from "axios";
import { server } from "../../server";

// Отримання фільтрів
export const getFilters = () => async (dispatch) => {
  try {
    dispatch({ type: "filtersRequest" });

    const { data } = await axios.get(`${server}/filter/get-filters`);

    dispatch({ type: "filtersSuccess", payload: data.filters });
  } catch (error) {
    dispatch({
      type: "filtersFail",
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Створення фільтра
export const createFilter = (filterData) => async (dispatch) => {
  try {
    dispatch({ type: "createFilterRequest" });

    const { data } = await axios.post(
      `${server}/filter/create-filter`,
      filterData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    dispatch({ type: "createFilterSuccess", payload: data.filter });
  } catch (error) {
    dispatch({
      type: "createFilterFail",
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Оновлення фільтра
export const updateFilter = (id, filterData) => async (dispatch) => {
  try {
    dispatch({ type: "updateFilterRequest" });

    const { data } = await axios.put(
      `${server}/filter/update-filter/${id}`,
      filterData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    dispatch({ type: "updateFilterSuccess", payload: data.filter });
  } catch (error) {
    dispatch({
      type: "updateFilterFail",
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Видалення фільтра
export const deleteFilter = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteFilterRequest" });

    await axios.delete(`${server}/filter/delete-filter/${id}`);

    dispatch({ type: "deleteFilterSuccess", payload: id });
  } catch (error) {
    dispatch({
      type: "deleteFilterFail",
      payload: error.response?.data?.message || error.message,
    });
  }
};
